import script from "./ProfileArchive.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileArchive.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import ConfirmModal from "@/components/ConfirmModal.vue";
import RecordButton from "@/components/customers/record/RecordButton.vue";
import RecordCard from "@/components/customers/record/RecordCard.vue";
import RecordSettingRow from "@/components/customers/record/RecordSettingRow.vue";
script.components = Object.assign({}, { ConfirmModal, RecordButton, RecordCard, RecordSettingRow }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { ConfirmModal, RecordButton, RecordCard, RecordSettingRow }, script.__o.components);}